"use strict";

var _regeneratorRuntime = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/regenerator/index.js");

var _objectWithoutProperties = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _asyncToGenerator = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _defineProperty = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/defineProperty.js");

var _classCallCheck = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/createClass.js");

var _get = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/get.js");

var _inherits = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/barroisantiq/barroisantiq/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _excluded = ["password", "email"],
    _excluded2 = ["password", "password2"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var deep_object_diff_1 = require("deep-object-diff");

var auth_1 = require("firebase/auth");

var firestore_1 = require("firebase/firestore");

var compact_1 = __importDefault(require("lodash/compact"));

var firebase_1 = require("../../config/firebase");

var Model_1 = __importDefault(require("../Model"));

var User = /*#__PURE__*/function (_Model_1$default) {
  _inherits(User, _Model_1$default);

  var _super = _createSuper(User);

  function User(props) {
    _classCallCheck(this, User);

    return _super.call(this, _objectSpread(_objectSpread({}, props), {}, {
      collectionName: 'users',
      orderDirection: (props === null || props === void 0 ? void 0 : props.orderDirection) || 'asc',
      orderField: (props === null || props === void 0 ? void 0 : props.orderField) || 'lastName'
    }));
  }

  _createClass(User, [{
    key: "initialize",
    value: function initialize(data) {
      return _get(_getPrototypeOf(User.prototype), "initialize", this).call(this, _objectSpread(_objectSpread({}, data), {}, {
        stripeAccountHidden: (data === null || data === void 0 ? void 0 : data.stripeAccountHidden) || false,
        stripeAccountVerified: (data === null || data === void 0 ? void 0 : data.stripeAccountVerified) || false
      }));
    }
  }, {
    key: "inscription",
    value: function () {
      var _inscription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        var documentSnapshot, password, email, others, userCredential, ref;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data.email) {
                  _context.next = 2;
                  break;
                }

                throw new Error('email obligatoire');

              case 2:
                _context.next = 4;
                return this.findByEmail(data.email);

              case 4:
                documentSnapshot = _context.sent;

                if (!(documentSnapshot && documentSnapshot.exists())) {
                  _context.next = 7;
                  break;
                }

                throw new Error('cet email est déjà utilisé par un compte');

              case 7:
                password = data.password, email = data.email, others = _objectWithoutProperties(data, _excluded);
                _context.next = 10;
                return (0, auth_1.createUserWithEmailAndPassword)(firebase_1.auth, email, password);

              case 10:
                userCredential = _context.sent;

                if (userCredential.user) {
                  _context.next = 13;
                  break;
                }

                throw new Error("erreur lors de la création de l'utilisateur");

              case 13:
                ref = (0, firestore_1.doc)(this.getCollectionRef(), userCredential.user.uid);
                _context.next = 16;
                return (0, firestore_1.setDoc)(ref, this.clean(_objectSpread(_objectSpread({}, others), {}, {
                  email: email
                }), true));

              case 16:
                return _context.abrupt("return", ref);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function inscription(_x) {
        return _inscription.apply(this, arguments);
      }

      return inscription;
    }()
  }, {
    key: "restauration",
    value: function () {
      var _restauration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(email) {
        var documentSnapshot;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.findByEmail(email);

              case 2:
                documentSnapshot = _context2.sent;

                if (!(!documentSnapshot || !documentSnapshot.exists())) {
                  _context2.next = 5;
                  break;
                }

                throw new Error("cet email n'est pas utilisé par un compte utilisateur");

              case 5:
                return _context2.abrupt("return", (0, auth_1.sendPasswordResetEmail)(firebase_1.auth, email));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function restauration(_x2) {
        return _restauration.apply(this, arguments);
      }

      return restauration;
    }()
  }, {
    key: "edition",
    value: function () {
      var _edition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id, values) {
        var ref, user, password, password2, others, diffValues, currentUser;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                ref = (0, firestore_1.doc)(this.getCollectionRef(), id);
                _context3.next = 3;
                return (0, firestore_1.getDoc)(ref);

              case 3:
                user = _context3.sent;
                password = values.password, password2 = values.password2, others = _objectWithoutProperties(values, _excluded2);
                diffValues = (0, deep_object_diff_1.diff)(user.data() || {}, others);
                currentUser = firebase_1.auth.currentUser;

                if (!currentUser) {
                  _context3.next = 20;
                  break;
                }

                if (!(password && password === password2)) {
                  _context3.next = 12;
                  break;
                }

                console.info('mise à jour du mot de passe');
                _context3.next = 12;
                return (0, auth_1.updatePassword)(currentUser, password);

              case 12:
                if (!(diffValues.email && others.email)) {
                  _context3.next = 16;
                  break;
                }

                console.info("mise à jour de l'email");
                _context3.next = 16;
                return (0, auth_1.updateEmail)(currentUser, others.email);

              case 16:
                if (!(diffValues.firstName || diffValues.lastName)) {
                  _context3.next = 20;
                  break;
                }

                console.info('mise à jour du displayName');
                _context3.next = 20;
                return (0, auth_1.updateProfile)(currentUser, {
                  displayName: (0, compact_1.default)([others.firstName, others.lastName]).join(' ').trim()
                });

              case 20:
                return _context3.abrupt("return", this.set(id, others));

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function edition(_x3, _x4) {
        return _edition.apply(this, arguments);
      }

      return edition;
    }()
  }, {
    key: "findByEmail",
    value: function () {
      var _findByEmail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(email) {
        var constraints, q, querySnapshot;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                constraints = [(0, firestore_1.where)('email', '==', email.toLowerCase().trim()), (0, firestore_1.where)('deleted', '==', false)];
                q = (0, firestore_1.query).apply(void 0, [this.getCollectionRef()].concat(constraints));
                _context4.next = 4;
                return (0, firestore_1.getDocs)(q);

              case 4:
                querySnapshot = _context4.sent;

                if (!(querySnapshot && !querySnapshot.empty)) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("return", querySnapshot.docs[0]);

              case 7:
                return _context4.abrupt("return", null);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function findByEmail(_x5) {
        return _findByEmail.apply(this, arguments);
      }

      return findByEmail;
    }()
  }, {
    key: "watchByUid",
    value: function () {
      var _watchByUid = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(uid, _next) {
        var constraints, q, querySnapshot, id, ref;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                constraints = [(0, firestore_1.where)('deleted', '==', false), (0, firestore_1.where)('uid', '==', uid)];
                q = (0, firestore_1.query).apply(void 0, [this.getCollectionRef()].concat(constraints));
                _context5.next = 4;
                return (0, firestore_1.getDocs)(q);

              case 4:
                querySnapshot = _context5.sent;

                if (!(0 === querySnapshot.size)) {
                  _context5.next = 7;
                  break;
                }

                throw new Error("L'utilisateur n'existe pas");

              case 7:
                if (!(querySnapshot.size > 1)) {
                  _context5.next = 9;
                  break;
                }

                throw new Error("Problème de configuration, l'utilisateur n'est pas unique");

              case 9:
                id = querySnapshot.docs[0].id;
                ref = (0, firestore_1.doc)(this.getCollectionRef(), id);
                return _context5.abrupt("return", (0, firestore_1.onSnapshot)(ref, {
                  next: function next(snapshot) {
                    if (!snapshot || !snapshot.exists() || snapshot.get('deleted')) {
                      return _next(undefined);
                    }

                    var document = _objectSpread({
                      id: id
                    }, snapshot.data());

                    return _next(document, snapshot.metadata);
                  }
                }));

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function watchByUid(_x6, _x7) {
        return _watchByUid.apply(this, arguments);
      }

      return watchByUid;
    }()
  }], [{
    key: "onChange",
    value: function onChange(next) {
      (0, auth_1.onAuthStateChanged)(firebase_1.auth, next);
    }
  }, {
    key: "get",
    value: function get() {
      return firebase_1.auth;
    }
  }, {
    key: "sendSignInLinkToEmail",
    value: function sendSignInLinkToEmail(email) {
      var actionCodeSettings = {
        handleCodeInApp: true,
        url: "".concat(String(process.env.GATSBY_URL_DOMAIN), "/signin")
      };
      window.localStorage.setItem('emailForSignIn', email);
      return (0, auth_1.sendSignInLinkToEmail)(firebase_1.auth, email, actionCodeSettings);
    }
  }, {
    key: "signInWithEmailLink",
    value: function signInWithEmailLink(href) {
      if ((0, auth_1.isSignInWithEmailLink)(firebase_1.auth, href)) {
        var email = window.localStorage.getItem('emailForSignIn');

        if (email) {
          (0, auth_1.signInWithEmailLink)(firebase_1.auth, email, window.location.href).then(function (result) {
            console.info('result', result);
            window.localStorage.removeItem('emailForSignIn');
            return true;
          }).catch(function (error) {
            console.error('error', error);
          });
        }
      }
    }
  }, {
    key: "signInAnonymously",
    value: function signInAnonymously() {
      return (0, auth_1.signInAnonymously)(firebase_1.auth);
    }
  }, {
    key: "signInWithEmailAndPassword",
    value: function () {
      var _signInWithEmailAndPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(email, password) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", (0, auth_1.signInWithEmailAndPassword)(firebase_1.auth, email, password));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function signInWithEmailAndPassword(_x8, _x9) {
        return _signInWithEmailAndPassword.apply(this, arguments);
      }

      return signInWithEmailAndPassword;
    }()
  }, {
    key: "signOut",
    value: function signOut() {
      return firebase_1.auth.signOut();
    }
  }, {
    key: "update",
    value: function update(user) {
      var currentUser = firebase_1.auth.currentUser;

      if (currentUser) {
        return (0, auth_1.updateProfile)(currentUser, {
          displayName: "".concat(user.firstName, " ").concat(user.lastName)
        });
      }

      return undefined;
    }
  }]);

  return User;
}(Model_1.default);

exports.default = User;